import {
  ROOT_CONTEXT,
  SpanContext,
  defaultTextMapGetter,
  trace,
} from '@opentelemetry/api';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { HeadersLike } from './headers-like.model';
import { isValidSpanContext } from './is-valid-span-context.function';
import { readHeader } from './read-header.function';
import { TRACEPARENT_HEADER } from './traceparent-header.constant';

const propagator = new W3CTraceContextPropagator();

export function extractSpanContext(
  headers: HeadersLike | undefined,
): SpanContext | undefined {
  const traceparent = readHeader(headers, TRACEPARENT_HEADER);

  if (!traceparent) {
    return undefined;
  }

  const extractedContext = propagator.extract(
    ROOT_CONTEXT,
    { [TRACEPARENT_HEADER]: traceparent },
    defaultTextMapGetter,
  );
  const spanContext = trace.getSpanContext(extractedContext);

  return isValidSpanContext(spanContext) ? spanContext : undefined;
}
